<div class="row p-2" *ngIf="assessment?.instructions">
  <div class="col-md-12 card card-body">
      <h4 class="h4-responsive text-center">{{assessment.name}}</h4>
      <div class="row text-light" *ngIf="hasInstructions()">
        <div class="col-12">
          <p class="alert  primary-color text-center h6-responsive" *ngIf="shouldShowInstructions()" (click)="hideInstructions()">
            <span class="fa fa-chevron-up" aria-hidden="true"></span>
            <span class="fa fa-chevron-up" aria-hidden="true"></span>
            <span class="fa fa-chevron-up" aria-hidden="true"></span>
            CLICK TO COLLAPSE INSTRUCTIONS
            <span class="fa fa-chevron-up" aria-hidden="true"></span>
            <span class="fa fa-chevron-up" aria-hidden="true"></span>
            <span class="fa fa-chevron-up" aria-hidden="true"></span>
          </p>
          <p class="alert  primary-color text-center h6-responsive" *ngIf="!shouldShowInstructions()" (click)="showInstructions()">
              <span class="fa fa-chevron-down" aria-hidden="true"></span>
              <span class="fa fa-chevron-down" aria-hidden="true"></span>
              <span class="fa fa-chevron-down" aria-hidden="true"></span>
            CLICK TO EXPAND INSTRUCTIONS
            <span class="fa fa-chevron-down" aria-hidden="true"></span>
            <span class="fa fa-chevron-down" aria-hidden="true"></span>
            <span class="fa fa-chevron-down" aria-hidden="true"></span>
          </p>
        </div>
      </div>
      <div class="row" *ngIf="shouldShowInstructions()">
          <div class="col-12">
            <div [innerHTML]="assessment?.instructions"></div>
          </div>
        </div>
      <div class="row" *ngIf="shouldShowInstructions()">
        <div class="col-12">
            <div [innerHTML]="currentQuestionSet?.instructions"></div>
        </div>
      </div>
  </div>
  
</div>
<div class="row p-2">
  <dac-question-set class="col" [questionSet]="currentQuestionSet"></dac-question-set>
</div>
<div class="row p-2">
  <div class="col card card-body">
      <div class="row">
        <div class="col-6 col-sm-3 col-md-2 order-1">
            <input *ngIf="hasPreviousSet" type="button" class="btn btn-primary" value="previous" (click)="previousSet()" />
        </div>
        <div class="col-12 col-sm-6 col-md-8 text-center order-3 order-md-2">
          <h4 class="h4-responsive">{{assessment?.name}}</h4>
            Page <span class="badge badge-pill badge-primary">{{currentIndex+1}}</span> of {{maxQuestionSetsIndex + 1}}
        </div>
        <div class="col-6 col-sm-3 col-md-2 text-right order-2 order-md-3">          
          <input *ngIf="hasNextSet" type="button" class="btn btn-primary" value="next" (click)="nextSet()" />
          <input *ngIf="!hasNextSet" [disabled]="disabled" type="button" class="btn btn-primary" value="Submit" (click)="submit()" />
          <!-- <input [disabled]="disabled" *ngIf="isAdmin" type="button" class="btn btn-primary" value="Select Sample" (click)="selectSample()" /> -->
        </div>
      </div>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/assessments/assessment/assessment.component.html